@if (filteredAlarms()) {
  <div>
    @if (filteredAlarms()?.length > 0) {
      <div class="history-item">
        <div>
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Created</th>
                <th>Resolved</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (alarm of filteredAlarms(); track alarm) {
                <tr (click)="alarmClick(alarm)" class="can-click">
                  <td>{{ alarm.createdAt | amDateFormat: 'DD/MM/yy HH:mm' }}</td>
                  <td>{{ alarm.findings?.at | amDateFormat: 'DD/MM/yy HH:mm' }}</td>
                  <td>{{ alarm.findings?.text }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="mt-1">
          @if (history) {
            <app-rulesv3-item-alarm-calendar [items]="filteredAlarms()"></app-rulesv3-item-alarm-calendar>
          }
        </div>
      </div>
    } @else {
      <div>
        <p class="mt-1">No alarms.</p>
      </div>
    }
  </div>
}
@if (alarm) {
  <div class="_modal">
    <main>
      <nav>
        <span (click)="alarm = null" class="can-click"><i class="mdi mdi-chevron-left"></i> Alarm</span>
      </nav>
      <app-rulesv3-item-alarm [assets]="assets" [alarm]="alarm"></app-rulesv3-item-alarm>
    </main>
  </div>
}
